import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ResizeService } from '@df/ui/common/resize.service';
import defaultsDeep from 'lodash-es/defaultsDeep';
import { CloudflareResizeService } from './cloudflare-resize.service';
import { NCloudflare } from './cloudflare.interface';

export function provideDfModuleCloudflare(config?: Partial<NCloudflare.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: ResizeService, useClass: CloudflareResizeService },
        {
            provide: NCloudflare.OPTIONS,
            useFactory: () => defaultsDeep(config, NCloudflare.DEFAULT_OPTIONS)
        }
    ]);
}
